// VOY-417 — shared utils for the v417 section components.

/**
 * Render any value as a display string. Used by CorrectionModal (read-mode
 * current value) and MemoryEditorSection (fact value). Booleans render as
 * "yes"/"no" — the agent context can carry booleans for has_passport-style
 * dimensions and "true"/"false" reads awkwardly to users.
 */
export function asString(v: unknown): string {
  if (v === null || v === undefined) return '—'
  if (typeof v === 'string') return v
  if (typeof v === 'number') return v.toString()
  if (typeof v === 'boolean') return v ? 'yes' : 'no'
  try { return JSON.stringify(v) } catch { return String(v) }
}
